import React from "react";
import { MdDragIndicator } from "react-icons/md";
import { IoEyeOutline } from "react-icons/io5";
import { MdDelete } from "react-icons/md";
import { Skeleton } from "@mui/material";

function ImageCardSkeleton() {
    const styles = {
        wrapper: {
            position: "relative",
            border: "1px solid #E4E4E7",
            borderRadius: "6px",
            overflow: "hidden",
            boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.1)",
            flexDirection: "row",
            userSelect: "none",
            backgroundColor: "white",
            cursor: "wait",
        },
        imgContainer: {
            width: "100%",
            height: "200px",
            display: "flex",
            position: "relative",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#f3f4f6",
            borderRadius: "6px 6px 0 0",
            background: "linear-gradient(90deg, rgba(0,0,0,0.1) 25%, rgba(0,0,0,0.05) 50%, rgba(0,0,0,0.1) 75%)",
            animation: "loading 1.2s infinite ease-in-out",
        },
        body: {
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "row",
            padding: "12px",
            actions: {
                display: "flex",
                gap: "8px"
            }
        },
        footer: {
            height: "59px",
            width: "100%",
            display: "none",
            padding: "8px 12px",
            backgroundColor: "#f3f4f6",
            borderTop: "1px solid #E4E4E7",
            color: "#E4E4E7",
            fontSize: "14px",
        },
        button: {
            width: "34px",
            height: "34px",
        }
    };

    return (
        <div style={styles.wrapper}>
            <div style={styles.imgContainer}>
                <Skeleton variant="rectangular" animation="wave" width="100%" height="100%" />
            </div>
            <div style={styles.body}>
                <div style={styles.body.actions}>
                    <Skeleton variant="rounded" animation="wave" style={styles.button} />
                    <Skeleton variant="rounded" animation="wave" style={styles.button} />
                </div>
                <div style={styles.body.dragContainer}>
                    <MdDragIndicator style={{ width: "18px", height: "18px", color: "#e0e0e0" }} />
                </div>
            </div>
            <div style={styles.footer}></div>
        </div>
    );
}

export default ImageCardSkeleton;
